const Item = ({items}) => {
	if (typeof items === 'undefined') return <></>;

	return items.map(
		(item: { index: number; title: string; description: string }) => {
			return (
				<li key={'item_' + item.index} className="how-to__list-item">
					<span className="how-to__list-item-header">{item.index}</span>  
					<span className="how-to__list-item-title">{item.title}</span>
					<p className="how-to__list-item-description">{item.description}</p>
				</li>
			);
		}
	);
}

export default Item;